export enum HeaderEnum
{
  NoAutentificar = 1,
  NoShowLoading,
  Paginacion,
}

export enum TipoIconoEnum
{
  AweSomeFont =1,
  Svg,
  SvgLocal
}

export enum TipoOpcionMenuEnum
{
  Modulo = 1,
  SubModulo,
  Pantalla,
  Funcion
}

export enum TipoDatoEnum
{
  Texto = 1,
  Numero,
  Decimal,
  Booleano,
  Fecha,
  Correo,
  URL
}

export enum PermisoEnum
{
  MaterialcodiciableAdministrar = 1,
  CargadeArchivosPCLAdministrar = 2,
  TipodeUsuarioAdministrar = 3,
  PantallasAdministrar = 4,
  SubmodulosAdministrar = 5,
  ParametrosAdministrar = 6,
  PlantilladecorreoAdministrar = 7,
  ModulosAdministrar = 8,
  UsuariosAdministrar = 10,
  PerfilesAdministrar = 11,
  ShippingInstructionsConsultar = 12,
  AsignaciondetransporteAdministrar = 13,
  ProveedoresAdministrar = 14,
  SitiosAdministrar = 15,
  DestinosMMVOAdministrar = 16,
  ShippingInstructionsCargarShippingInstruction = 17,
  ShippingInstructionsExportarPDF = 18,
  ShippingInstructionsExportarExcel = 19,
  ShippingInstructionsEliminarordenes = 20,
  ShippingInstructionsDescargarLayoutSIConvert = 21,
  EscaneoShippingInstructionAdministrar = 23,
  SolicitarMaterialCriticoAdministrar = 24,
  AprobaciondeMaterialCriticoAdministrar = 25,
  RecepcionenEventosAdministrar = 26,
  RecepciondeMaterialCodiciableAdministrar = 27,
  RecepciondeMaterialTCFAdministrar = 28,
  ReimpresiondeEtiquetasConsultar = 29,
  InspecciondeMaterialAdministrar = 30,
  RecepcionenSQEAdministrar = 31,
  ConsultaSIInternaAdministrar = 32,
  PalletSpecificationsAdministrar = 33,
  CargadeDDBAyPalletSpecificationCargarPalletSpecification = 34,
  ReimpresiondeEtiquetasReimprimirEtiquetas = 35,
  CargadeDDBAyPalletSpecificationCargarDDBA = 36
}

export enum RespuestaEstatusEnum
{
  Success = 200,
  Parcial = 206,
  NoAutorizado = 401
}

export enum FuncionesUsuarioEnum
{
  CambiarPassword = 1,
  CerrarSesion,
  CerrarSesionEnmascarado
}

export enum PersonalidadJuricaEnum
{
  Moral = 1,
  Fisica
}

export enum TipoUsuarioEnum
{
  Mazda = 1,
  Proveedor
}

export enum ProcesoImportarEnum
{
  Inico = 1,
  Procesando,
  Validado,
  EnEspera,
  Expotando,
  Finalizado,
  Error,
}


export enum EstatusProcesoEnum
{
  Pendiente = 1,
  Procesando,
  Success,
  Error
}

export enum TipoArchivoEnum
{
  PDF = 1,
  Excel,
}

export enum PlataformaEnum
{
  Todas = 1,
  Web,
  Movil,
}

export enum EstatusOrdenEnum
{
  Abierta = 1,
  TransitoParcial,
  TransitoCompleta,
  Cerrada,
}

export enum EstatusSolicitudEnum
{
  Pendiente = 1,
  Autorizado,
  Rechazdo,
}

export enum EstatusCalidadEnum
{
  Ninguno = 1,
  Sospechoso,
  OK,
  NG
}

export enum EstatusCambioMaterialEnum
{
  Pendiente = 1,
  Approval,
  CargoSeguro,
  Reemplazado
}

export enum ApiEnum
{
  Seguridad = 1,
  Rest,
}

export enum TipoEtiquetaEnum
{
  ML = 1,
  MIX,
}

export enum CargaDatosEnum
{
  DDBA = 1,
  PalletSpecification,
}

export enum EstatusRevisionEnum
{
  PorAtender = 1,
  Vista,
  Descargada
}

export enum TipoAccionEvaluacionEnum
{
  Agregar = 1,
  Actualizar,
  Eliminar,
  Administrar
}


